import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"
import type { SingleCoupon } from "./interface/couponInterface"

/** 优惠券 */
export async function getNotJoinActivity(): Promise<SingleCoupon[]> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/activity?type=notJoin', {})
}


// 我的优惠券
// 1 CLAIMED type=1 - 已领取 待使用
// 2 USED type=2 - 已使用
// 3 EXPIRED type=3 - 已失效
export const getActivityCoupons = async (type: string): Promise<SingleCoupon[]> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get(`/v1/api/activity/coupons?type=${type}`, {})
}

// 领取优惠券
export const claimCoupon = async (id: number) => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post(`/v1/api/activity/${id}/coupons/claim`, {})
}
